import { load } from "@shopify/theme-sections"
import "../sections/template-cart"
import "../../styles/templates/cart.scss"

load([`template-cart`])
